/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import ESIC_logo from 'assets/img/form_logo/esci_form_logo.png';

export const ESICDeclarationForm = ({ data }) => {
  if (!data) {
    return null;
  }

  const {
    personal_information,
    identification_details,
    financial_details,
    professional_details
  } = data;

  return (
    <React.Fragment>
      <style>
        {`body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 8px;
        font-size: 10px;
        line-height: 1.2;
      }
      .container {
        max-width: 800px;
        margin: 0 auto;
        padding: 8px;
        background-color: white;
      }
      .header {
        text-align: center;
        margin-bottom: 8px;
      }
      .form-number {
        text-align: center;
        font-weight: bold;
        margin-bottom: 8px;
        font-size: 11px;
      }
      .title-section {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
      }
      .logo {
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* margin-right: 15px; */
        flex-shrink: 0;
      }
      .title-text {
        flex: 1;
        text-align: center;
      }
      .main-title {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 3px;
      }
      .hindi-title {
        font-size: 12px;
        margin-bottom: 3px;
      }
      .subtitle {
        font-size: 9px;
        margin-bottom: 3px;
        text-align: left;
      }
      .form-info {
        font-size: 8px;
        text-align: right;
        margin-bottom: 8px;
      }
      .two-column {
        display: flex;
        gap: 10px;
      }
      .column {
        flex: 1;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 5px;
      }
      th,
      td {
        border: 1px solid #000;
        padding: 2px 4px;
        text-align: left;
        vertical-align: top;
        font-size: 10px;
      }
      th.dashed,
      td.dashed {
        border: 1px dashed #000;
        border-left-style: solid;
        border-right-style: solid;
      }
      th.dashed.only-top,
      td.dashed.only-top {
        border-bottom-style: solid;
      }
      .field-label {
        width: 50%;
      }
      .field-value {
        font-weight: bold;
        width: 50%;
      }
      .checkbox {
        width: 10px;
        height: 10px;
        border: 1px solid #000;
        display: inline-block;
        margin-right: 3px;
        vertical-align: middle;
      }
      .signature-section {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
      }
      .signature-box {
        text-align: center;
        width: 200px;
        border-top: 1px solid #000;
        padding-top: 5px;
      }
      .print-button {
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 10px 20px;
        background-color: #4caf50;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        z-index: 1000;
      }
      .print-button:hover {
        background-color: #45a049;
      }
      .family-table {
        margin: 5px 0;
      }
      .family-table th {
        background-color: #f0f0f0;
        font-size: 8px;
        text-align: center;
      }
      .family-table td {
        font-size: 9px;
      }
      .esic-card {
        border: 2px solid #000;
        padding: 5px;
        margin: 5px 0;
      }
      .card-header {
        text-align: center;
        font-weight: bold;
        margin-bottom: 5px;
      }
      .card-content {
        display: flex;
        gap: 10px;
      }
      .card-right {
        width: 80px;
        border: 1px solid #000;
        text-align: center;
        padding: 20px 5px;
        font-size: 8px;
      }
      .hindi-text {
        font-family: "Devanagari Sangam MN", "Noto Sans Devanagari", sans-serif;
      }

      /* Print specific styles */
      @media print {
        body {
          margin: 0;
          padding: 0;
          background-color: white;
          font-size: 9px;
        }
        .container {
          max-width: 100%;
          border: 1px solid #000;
          padding: 5px;
          margin: 0;
        }
        .print-button {
          display: none;
        }
        table {
          page-break-inside: avoid;
        }
        @page {
          size: A4;
          margin: 0.3cm;
        }
      }`}
      </style>
      <div className="container">
        <div className="title-section">
          <div className="logo">
            <img
              src={ESIC_logo}
              alt="ESIC Logo"
              style={{ width: '80%', height: 'auto' }}
            />
          </div>
          <div className="title-text">
            <div className="main-title">घोषणा पत्र DECLARATION FORM</div>
            <div className="subtitle hindi-text">
              घोषणा प कमचारी द्वारा भरा जाएगा । फाम के साथ पोस्टकार्ड आकार के दो
              फोटोग्राफ भी लगाए जाने चािहए । फाम भरने से पहले पीठ पृ पर दी गई
              िहदायतों को भली-भांति पढ़ लेना चािहए । यह फाम नि शुल्क है ।
            </div>
            <div className="subtitle">
              To be filled by employee after reading instruction overleaf. Two
              Postcard Size photographs to be attached with the form. This form
              is free of cost.
            </div>
          </div>
        </div>
        <div className="form-info">फार्म नं./Form-1</div>
        <div className="two-column">
          <div className="column">
            <div className="section-header">(क) बीमाकृत का िववरण</div>
            <div className="section-header">
              (A) INSURED PERSON'S PARTICULARS
            </div>
            <table style={{ tableLayout: 'fixed' }}>
              <tbody>
                <tr>
                  <td className="field-label">1. बीमा संख्या/Insurance No.</td>
                  <td className="field-value" colSpan={5}></td>
                </tr>
                <tr>
                  <td className="field-label">
                    2. नाम (ब्लॉक अक्षरों में)/Name in block letters
                  </td>
                  <td className="field-value" colSpan={5}>
                    {personal_information.first_name}{' '}
                    {personal_information.last_name}
                  </td>
                </tr>
                <tr>
                  <td className="field-label">
                    3. पिता/पति का नाम/Father's/Husband's Name
                  </td>
                  <td className="field-value" colSpan={5}>
                    {personal_information.spouse_name ??
                      personal_information.father_name}{' '}
                    ({personal_information.spouse_name ? 'H' : 'F'})
                  </td>
                </tr>
                <tr>
                  <td rowSpan={2} className="field-label">
                    4. जन्म की तिथि/Date of Birth
                  </td>
                  <td>दि. / Day</td>
                  <td>महीना / Month:</td>
                  <td>वर्ष / Year:</td>
                  <td>5. लिंग / Sex:</td>
                  <td className="field-value">
                    {personal_information.gender === 'Male'
                      ? 'पु./M'
                      : 'स्त्री/F'}
                  </td>
                </tr>
                <tr>
                  <td className="field-value">
                    {personal_information.date_of_birth?.split('-')[2]}
                  </td>
                  <td className="field-value">
                    {personal_information.date_of_birth?.split('-')[1]}
                  </td>
                  <td className="field-value">
                    {personal_information.date_of_birth?.split('-')[0]}
                  </td>
                  <td>6. वैवाहिक स्थिति / Marital Status:</td>
                  <td className="field-value">
                    {personal_information.marital_status === 'Married'
                      ? 'वि./M'
                      : 'अवि./UM'}
                  </td>
                </tr>
                <tr>
                  <td className="dashed field-label">
                    7. वर्तमान पता/Present Address: <br />
                    <strong>{personal_information.current_address}</strong>
                  </td>
                  <td className="field-label dashed" colSpan={5}>
                    8. स्थायी पता/Permanent Address: <br />
                    <strong>{personal_information.permanent_address}</strong>
                  </td>
                </tr>
                <tr>
                  <td className="field-label dashed">
                    पिन कोड/PIN Code:
                    {/* <strong>768201</strong> */}
                  </td>
                  <td className="field-label dashed" colSpan={5}>
                    पिन कोड/PIN Code:
                    {/* <strong>768201</strong> */}
                  </td>
                </tr>
                <tr>
                  <td className="field-label dashed">
                    <div>
                      <div>टेलीफोन नं./Telephone No.:</div>
                      <div style={{ height: '10px' }}>
                        <strong>{personal_information.employee_mobile}</strong>
                      </div>
                    </div>
                  </td>
                  <td className="field-label dashed" colSpan={5}>
                    टेलीफोन नं./Telephone No.:{' '}
                    <strong>{personal_information.alternate_mobile}</strong>
                  </td>
                </tr>
                <tr>
                  <td className="field-label dashed">
                    <div>
                      <div>ईमेल पता/Email Address: </div>
                      <div style={{ height: 10 }}>
                        <strong>{personal_information.employee_email}</strong>
                      </div>
                    </div>
                  </td>
                  <td className="field-label dashed" colSpan={5}>
                    ईमेल पता/Email Address: <br />
                    <strong />
                  </td>
                </tr>
                <tr>
                  <td className="field-label dashed only-top">
                    शाखा कार्यालय/Branch Office: <br />
                    <strong>{professional_details.branch_name}</strong>
                  </td>
                  <td className="field-label dashed only-top" colSpan={5}>
                    शाखा कार्यालय/Branch Office: <br />
                    <strong>{professional_details.branch_name}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="column">
            <div className="section-header">(ख) नियोजक के विवरण</div>
            <div className="section-header">(B) EMPLOYER'S PARTICULARS</div>
            <table style={{ tableLayout: 'fixed' }}>
              <tbody>
                <tr>
                  <td className="field-label">
                    9. नियोजक का कोड संख्या/Employer's Code No.
                  </td>
                  <td className="field-value" colSpan={3}>
                    4459002402001001
                  </td>
                </tr>
                <tr>
                  <td rowSpan={2} className="field-label">
                    10. नियुक्ति की तारीख/Date of Appointment
                  </td>
                  <td>दि. / Day</td>
                  <td>महीना / Month</td>
                  <td>वर्ष / Year</td>
                </tr>
                <tr>
                  <td className="field-value">
                    {/* {
                      (professional_details?.date_of_joining || '')?.split(
                        '-'
                      )[2]
                    } */}
                  </td>
                  <td className="field-value">
                    {/* {
                      (professional_details?.date_of_joining || '')?.split(
                        '-'
                      )[2]
                    } */}
                  </td>
                  <td className="field-value">
                    {/* {
                      (professional_details?.date_of_joining || '')?.split(
                        '-'
                      )[2]
                    } */}
                  </td>
                </tr>
                <tr>
                  <td className="field-label" colSpan={4}>
                    11. नियोजक का नाम और पता/Name and Address of Employer
                    <br />
                    <strong>
                      KALVANI VENTURES MECHANICAL PRIVATE LIMITED
                      <br />
                      NEAR VEDANTA CHOWK, SUNARMUNDA, P.O.- SARABAHAL,
                      <br />
                      DIST.- JHARSUGUDA, ODISHA- 768201
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td className="field-label" colSpan={4}>
                    <div>
                      12. यदि पहले से नियोजित है तो पूर्व नियोजन का विवरण/If
                      already employed fill up the details as under
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="field-label" colSpan={4}>
                    <div>
                      <div>(क) पूर्व बीमा संख्या/(a) Previous Ins. No.</div>
                      <div style={{ height: 16 }} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="field-label" colSpan={4}>
                    <div>
                      <div>(ख) नियोजक कोड संख्या/(b) Employer's Code No.</div>
                      <div style={{ height: 16 }} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="field-label" colSpan={4}>
                    <div>
                      <div>
                        (ग) नियोजक का नाम और पता/(c) Name &amp; Address of the
                        Employer
                      </div>
                      <div style={{ height: 16 }} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="field-label" colSpan={4}>
                    टेलीफोन नं./Telephone No.:
                  </td>
                </tr>
                <tr>
                  <td className="field-label" colSpan={4}>
                    ईमेल पता/Email Address:
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style={{ fontSize: 8, margin: '5px 0' }}>
          (घ) ई.एस.आई. अधिनियम के अंतर्गत नामांकन के लिए नियम 71 के अनुसार
          मृत्यु की स्थिति में नकद लाभ के भुगतान के लिए ई.एस.आई. (केंद्रीय)
          नियम, 1950 के नियम 5(2) के अंतर्गत नामांकन के विवरण।
          <br />
          (d) Details of Nominee u/s 71 of ESI Act 1948/Rule-5(2) of ESI
          (Central) Rules, 1950 for payment of cash benefit in the event of
          death.
        </div>
        <table className="family-table">
          <tbody>
            <tr>
              <th>नाम/Name</th>
              <th>संबंध/Relationship</th>
              <th>पता/Address</th>
            </tr>
            <tr>
              <td height={'12px'}></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div style={{ fontSize: 8, margin: '5px 0', marginBottom: 30 }}>
          मैं एतद्द्वारा घोषणा करता/करती हूं कि मेरे द्वारा दी गई जानकारी मेरी
          जानकारी और विश्वास के अनुसार सही है। मैं अपने परिवार की सदस्यता में
          किसी भी प्रकार के परिवर्तन की सूचना निगम को 15 दिन के अंदर देने का वचन
          देता/देती हूं।
          <br />I hereby declare that the particulars given by me are correct to
          the best of my knowledge and belief. I undertake to intimate the
          corporation any changes in the membership of my family within 15 days
          of such change.
        </div>
        <div className="signature-section">
          <div>
            <div>
              नियोजक के प्रतिहस्ताक्षर <br />
              Counter signature by the employer
            </div>
            <div style={{ marginTop: 30 }}>
              सील सिहत हस्ताक्षर/Signature with seal
            </div>
          </div>
          <div className="signature-box">
            <div>बीमाकृत के हस्ताक्षर/अंगूठा िनशान</div>
            <div>Signature T.I of IP.</div>
          </div>
        </div>
        <div style={{ fontSize: 8, margin: '10px 0' }}>
          (घ) बीमाकृत व्यक्ति के परिवार का विवरण/(d) Family Particulars of
          Insured person
        </div>
        <table className="family-table">
          <tbody>
            <tr>
              <th rowSpan={2}>क्र./ Sr.No.</th>
              <th rowSpan={2}>नाम/Name</th>
              <th rowSpan={2}>
                जन्म तिथि की तारीख के आधार पर आयु/Date of Birth/Age as on date
                of filling form
              </th>
              <th rowSpan={2}>
                कर्मचारी के साथ संबंध/Relationship with the Employee
              </th>
              <th colSpan={2}>
                उसके साथ रह रहे हैं या नहीं/Whether residing with him or her?
              </th>
              <th colSpan={2}>
                यदि नहीं तो आवास का स्थान/If 'NO', state place of residence
              </th>
            </tr>
            <tr>
              <th>हां/Yes</th>
              <th>नहीं/No</th>
              <th>का./Town</th>
              <th>रा./State</th>
            </tr>
            <tr>
              <td>1</td>
              <td></td>
              <td />
              <td></td>
              <td></td>
              <td />
              <td />
              <td />
            </tr>
            <tr>
              <td>2</td>
              <td />
              <td />
              <td></td>
              <td></td>
              <td />
              <td />
              <td />
            </tr>
            <tr>
              <td>3</td>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
            </tr>
            <tr>
              <td>4</td>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
            </tr>
            <tr>
              <td>5</td>
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
              <td />
            </tr>
          </tbody>
        </table>
        <div style={{ marginTop: 6, marginBottom: 6 }}>
          <div style={{ display: 'inline-block', width: '50%' }}>
            कर्मचारी राज्य बीमा निगम अस्थायी पहचान पत्र
            <br />
            ESI Corporation Temporary Identity Card
          </div>
          <div style={{ display: 'block', width: '50%', float: 'right' }}>
            (नियुक्ति की तारीख से 3 महीने तक वैध)
            <br />
            (Valid for 3 month from the date of appointment)
          </div>
        </div>
        <div>
          <div className="">
            <div className="" style={{ display: 'inline-block', width: '65%' }}>
              <table style={{ tableLayout: 'fixed' }}>
                <tbody>
                  <tr>
                    <td width="32%">नाम/Name</td>
                    <td colSpan={3}>
                      <strong>
                        {personal_information.first_name}{' '}
                        {personal_information.last_name}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td>बीमा संख्या/Insurance No.</td>
                    <td>
                      <strong></strong>
                    </td>
                    <td>नियुक्ति की तारीख/Date of Appointment</td>
                    <td>
                      <strong>{professional_details?.date_of_joining}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>शाखा कार्यालय/Branch Office:</td>
                    <td>
                      <strong>JHARSUGUDA</strong>
                    </td>
                    <td>औषधालय/Dispensary:</td>
                    <td>
                      <strong>JHARSUGUDA</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      नियोजक का कोड संख्या और पता <br />
                      Employer's Code No and Address
                    </td>
                    <td colSpan={3}>
                      <strong>
                        4459002402001001
                        <br />
                        KALVANI VENTURES LIMITED
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="card-right" style={{ float: 'right' }}>
              फोटो के लिए स्थान
              <br />
              (Space for photograph)
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 10
            }}
          >
            <div>
              <div>
                <div>Validity:</div>
                <div>__________________________________</div>
              </div>
              <div style={{ marginTop: 5 }}>
                <div>Dated:</div>
                <div>__________________________________</div>
              </div>
            </div>
            <div style={{ marginTop: 30 }}>
              <div style={{ textAlign: 'center' }}>
                बीमाकृत के हस्ताक्षर/अंगूठा िनशान
                <br />
                Signature T.I of I.P.
              </div>
              <div style={{ clear: 'both' }} />
            </div>
            <div style={{ textAlign: 'center', marginTop: 30 }}>
              सील सिहत शाखा बंधक के हस्ताक्षर
              <br />
              Signature of B.M. with seal
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
